import React, { useState, useEffect, useRef } from "react";

import { PageInfo } from "MVVM/Views/MatchHistory/@types";

interface CursorPaginationProps {
  pageInfo: PageInfo;
  onBottomHit: () => void;
  isLoading: boolean;
  loadOnMount: boolean;
  children: React.ReactNode;
}

function isBottom(
  ref: React.RefObject<HTMLDivElement>,
  parent: HTMLElement | null,
) {
  if (!ref.current || !parent) {
    return false;
  }
  const rect = ref.current.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();

  return rect.bottom <= parentRect.bottom;
}

export const InfiniteScrollPagination = ({
  pageInfo,
  children,
  onBottomHit,
  isLoading,
  loadOnMount,
}: CursorPaginationProps) => {
  const [initialLoad, setInitialLoad] = useState(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const mainContainer = document.getElementById("main");

  const hasNextPage = pageInfo?.hasNextPage ?? false;

  useEffect(() => {
    if (loadOnMount && initialLoad) {
      onBottomHit();
      setInitialLoad(false);
    }
  }, [onBottomHit, loadOnMount, initialLoad]);

  useEffect(() => {
    const onScroll = () => {
      if (!isLoading && hasNextPage && isBottom(contentRef, mainContainer)) {
        onBottomHit();
      }
    };
    if (mainContainer) mainContainer.addEventListener("scroll", onScroll);
    return () => {
      if (mainContainer) mainContainer.removeEventListener("scroll", onScroll);
    };
  }, [onBottomHit, isLoading, hasNextPage, mainContainer]);

  if (!pageInfo) return <></>;

  return <div ref={contentRef}>{children}</div>;
};
